var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ExecuteDetailToggleMechanism from './Utilities/DetailsToggleMechanism';
import ReadingTime from './Utilities/ReadingTime';
ExecuteDetailToggleMechanism();
ReadingTime();
//swiper
import Swiper, { Pagination, Autoplay, Virtual } from 'swiper';
{
    var swiper_1 = new Swiper('[data-swiper="spiele"]', {
        modules: [Pagination, Autoplay],
        rewind: true,
        spaceBetween: 20,
        speed: 500,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 1,
            clickable: true,
        },
    });
}
function shuffle(array) {
    var _a;
    var currentIndex = array.length;
    while (currentIndex != 0) {
        var randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        _a = [
            array[randomIndex], array[currentIndex]
        ], array[currentIndex] = _a[0], array[randomIndex] = _a[1];
    }
    return array;
}
var getTemplates = function (template) {
    var clone = template.content.cloneNode(true);
    return Array.from(clone.querySelectorAll('.swiper-slide'));
};
var orte = document.querySelectorAll('template');
var overview = getTemplates(orte[0]);
console.log(overview);
var allOrtSlides = [];
var arrayofallOrtSlides = [];
for (var i = 0; i < orte.length; i++) {
    var templates = getTemplates(orte[i]);
    allOrtSlides.push.apply(allOrtSlides, templates);
    arrayofallOrtSlides.push(templates);
}
var allSlides = shuffle(allOrtSlides);
var swiper = new Swiper('.shuffle', {
    modules: [Virtual, Pagination, Autoplay],
    spaceBetween: 20,
    rewind: true,
    centeredSlides: true,
    speed: 500,
    initialSlide: 0,
    on: {
        init: function () {
            console.log('Number of slides:', this.slides.length);
        }
    },
    virtual: {
        enabled: true,
        cache: false,
        slides: overview.map(function (item) { return item.outerHTML; }),
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: true,
        stopOnLastSlide: false,
    },
    breakpoints: {
        640: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        1364: {
            slidesPerView: 2.5,
            spaceBetween: 20,
        },
        1620: {
            slidesPerView: 2.7,
            spaceBetween: 20,
        },
    },
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        dynamicMainBullets: 1,
        clickable: true,
    },
});
// Select + onchange Event
var region = document.getElementById('region-select');
if (region) {
    region.addEventListener('change', function (e) {
        var d = (document.getElementById("region-select"));
        var sel = d.selectedIndex;
        if (sel === 1) {
            doSwiperStuff(overview);
        }
        else {
            doSwiperStuff(arrayofallOrtSlides[sel - 1]);
        }
    });
}
var doSwiperStuff = function (destination) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        swiper.virtual.removeAllSlides();
        swiper.virtual.update(true);
        swiper.virtual.appendSlide(destination.map(function (item) { return item.outerHTML; }));
        return [2 /*return*/];
    });
}); };
//aos
import * as AOS from "aos";
AOS.init();
AOS.refresh();
//lang collapser
document.querySelector('.collapser-button').addEventListener('click', function () {
    var collapser = document.querySelector('.lang-collapser');
    collapser.classList.toggle('open');
});
//lenis
import Lenis from '@studio-freight/lenis';
var lenis = new Lenis({
    duration: 1.3,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
});
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        lenis.scrollTo(this.getAttribute('href'));
        var target = document.querySelector(this.getAttribute('href'));
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true, focusVisible: false });
        target.addEventListener('blur', function () {
            target.removeAttribute('tabindex');
        });
        target.addEventListener('focusout', function () {
            target.removeAttribute('tabindex');
        });
    });
});
